import { COMMENTS_SIZE, OrderDirection } from '../../../shared';
import { commentQuery } from './commentQuery';
import { eventQuery } from './eventQuery';
import { storyCardContentQuery } from './storyCardContentQuery';
import { storyQuery } from './storyQuery';

interface StoryCardQueryArgs {
  isFeed: boolean;
  isAdminLayout: boolean;
}

export const storyCardQuery = ({ isFeed, isAdminLayout }: StoryCardQueryArgs) => `
  apiClient {
    type
    name
  }
  localeId
  author {
    avatar {
      averageColor
      externalId
      externalType
      id
      originalFilename
      rightholder
      status
      statusCopyrightId
      thumb
      url
    }
    email
    id
    screenName
  }
  user {
    avatar {
      averageColor
      externalId
      externalType
      id
      originalFilename
      rightholder
      status
      statusCopyrightId
      thumb
      url
    }
    email
    id
    screenName
  }
  mentionedUsers {
    avatar {
      averageColor
      externalId
      externalType
      id
      originalFilename
      rightholder
      status
      statusCopyrightId
      thumb
      url
    }
    email
    id
    screenName
  }
  category {
    id
    name
    settings {
      userSelection
    }
  }
  authorId
  isReadOnly
  isBookmarked
  commentsCount(filters: {showHidden: ${isAdminLayout}})
  commentsRootCount(filters: {showHidden: ${isAdminLayout}})
  status
  assignedUserId
  originalUserId
  isPinnedToTopOfNewsFeed
  isPinnedToTopOfStory
  section
  content {
    ${storyCardContentQuery({ isFeed })}
  }
  createdAt
  dateToDisplay
  ${
    isFeed
      ? 'comments: highlightedComments'
      : `comments(size: ${COMMENTS_SIZE}, filters: {showHidden: ${isAdminLayout}})`
  } {
    ${commentQuery(2, OrderDirection.ASC)}
  }
  event {
    ${eventQuery}
  }
  eventId
  id
  myReaction
  options {
    allowCardReaction
    allowComment
    allowDisplayAuthor
    allowSharing
    shouldUpdatePostedTimeByComments
  }
  externalTags: organisationTags(filters: {types: [EXTERNAL]}) {id name type }
  externalStatusTags: organisationTags(filters: {types: [EXTERNAL_STATUS]}) {id name type }
  ${
    isAdminLayout
      ? `internalTags: organisationTags(filters: {types: [INTERNAL]}) { id name type }`
      : ''
  }
  permissions {
    allowToDelete
    allowToUpdate
    allowToUpdatePosition
    allowToUpdateStatus
    allowToPinToNewsfeed
    allowToPinToStory
    allowToSeeChangeLog
  }
  position
  postedAt
  postingTime
  published
  reactions {
    count
    name
  }
  story {
    ${storyQuery({ isAdminLayout })}
  }
  storyId
  type
  updatedAt
`;
